import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TranslateService } from '@ngx-translate/core';
import { AppVersion } from '@ionic-native/app-version';
import { Storage } from '@ionic/storage';

import { LoginPage } from '../pages/login/login';
import { BriefcasePage } from '../pages/briefcase/briefcase';
import { FilRougePage } from '../pages/fil-rouge/fil-rouge';
import { RecentsPage } from '../pages/recents/recents';
import { FavoritesPage } from '../pages/favorites/favorites';
import { SearchPage } from '../pages/search/search';
import { LocalFilesPage } from '../pages/local-files/local-files';
import { NotificationsPage } from '../pages/notifications/notifications';
import { EmailPackagePage } from '../pages/email-package/email-package';
import { HelperProvider } from '../providers/helper/helper';
import { ENV } from '@app/env';
import { SynchroProvider } from '../providers/synchro/synchro';
import { AuthProvider } from '../providers/auth/auth';



@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = LoginPage;
  pages: Array<{id: number, title: string, component: any, icon: string}>;
  activePage: any;
  wsUrl: string = ENV.wsUrl;
  licenceKey: string = ENV.pspLicensekey;
  licenseSet: boolean = false;
  lastSyncDate: string;
  isIosPlatform: boolean;
  currentAppVersion: string;
  //private licenceKey = "usnZI4Q5leMNVODisVdLpJyT961vzbcSQ1A5F3XlQoInniATCQ7uvLKgA+952ZkEEx11vbaxNjWaZnyuWxkGAzmlWc75Z/Q073nt5vXi43KrKoDV1b9r810hivCYKWqnTmWyY3C/NdM75B/W8XgC5rFKZTcesK/9LduMq3Alh8s7W07oar7ivASlMr5Kkz7kF6U07o81eK6BwRZarHzjirfUcE281To2JLp8tZiTiAthYjFrekqXoolzDyW3sspbY+FfUSjJlNFjiJGQOzBHvF5Gw51ABtTIUvj/bV1YSMwWiX7XWPFcSviSofBPAwRfp7+5ANnDOhdPeIT3gOLJwEuOm4l6vhF0t5US/kDlxJsGqAqNXKS0H0CX5ldPXrALNiN2D6sfx6hqK9RORa9VI/IN3z4RVM6NS+Wi6azkdiYgtHZw8ww1hys4RLW/3EZpdEk3uMrm6Gy2X3GFCVbSGxhYlDXb0Ih7mSpRb9VJvihD+dsZDNsFzL+PYN6uNKexAa5UaCXdLcHNk+cbJWTB7xXDnOzahwk+Klm6rQyGoPcF/0fdWcGwBTb9w4vJUnrgqmMqICOCnvjEynds9hXNiBL3HWwY0bgamjKuP3YCFaA=";
  //private demoLicenceKey = "cY5fgELgh66ir/bfdVMCEIXB64ifie8+V8Qk+/3QN8RCdmKjG7bAfXGb+kl6/Jac7echCyb9q9A8yqZ6LTrIwQi6E4Ri31Y7aIpQ4DA/hGwpRKILBU6/D2yyqcK/Av5YwL35WVwhGhRKLnXgZl/tosHAonrbTAkEJlnqwr7MPkM9HZe7zrJ96odiIlrT7LTBmZUal10aLXje9cHnKsujDXizVGCXmsXOigUxLafGwY9WZxWxepJlO+ehIZrL6TWPALl97xYROKH8yksugWYFcwmRMdNg3avCmsLnfC2NHd6sD3mm/ll4m53q0Ypr5qhkYRd9t4WoK/fzjVayHa/5XWSWIHCIJ5MOeVNW9ckgXeLmJEwa2PrEs1qa1up9NQWO6d2nm/aThmNAyjxRKrRMeoBC3+IMxCb5EPnvlTG8/J4evUIQfhj+KN2JReluRTLD";

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private translate: TranslateService,
    public helperService: HelperProvider, 
    public storage: Storage,
    public synchroService: SynchroProvider,
    private appVersion: AppVersion,
    public authService: AuthProvider) 
  {
    // this.isIosPlatform = this.platform.is('ios');
    //[VP - 27/01/2021] Use custom function to detect iOS because of ionic bug: https://github.com/ionic-team/ionic-v3/issues/1104
    this.isIosPlatform = this.helperService.isIOS();
    this.lastSyncDate = "";
    this.initializeApp();
    this.pages = [];
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if(typeof wkWebView !== "undefined"){
        wkWebView.injectCookie(this.wsUrl);
      }

      if (this.isIosPlatform) {
        // make your native API calls
        this.initCordovaApp();
      } else {
        // fallback to browser APIs
        this.initWebApp();
      }

      this.translate.addLangs(['de', 'fr', 'it']);
      this.translate.setDefaultLang('de');
      this.translateMenu();

      this.getAppVersion();
      this.getSynchroDate();

      this.platform.pause.subscribe(() => {
            console.log('[INFO] App paused');
            let pauseDate = Date.now();
            this.storage.set("pauseDate", pauseDate);
            console.log('Pause Date: '+ pauseDate);
      });

      this.platform.resume.subscribe(() => {
          console.log('[INFO] App resumed');
          let nowDate = Date.now();
          console.log('Resume Date: '+ nowDate);
          this.storage.get("pauseDate").then(pauseDate => {
            let between = this.helperService.getHoursBetweenDates(nowDate, pauseDate);
            console.log("BETWEEN: "+ between);
            if(between >= 1){
              this.logOut();
            }
          });
      });

    });

    this.storage.ready().then(() => {
      console.log("***STORAGE: ",this.storage.driver);
    });
  }

  initCordovaApp(){
    console.log("init cordova app !");
    // Okay, so the platform is ready and our plugins are available.
    // Here you can do any higher level native things you might need.
    this.statusBar.hide();
    this.splashScreen.hide();

    if(typeof PSPDFKit !== "undefined" && this.isIosPlatform && !this.licenseSet){
      console.log("PSPDFKIT SET LICENSE");
      PSPDFKit.setLicenseKey(this.licenceKey);
      this.licenseSet = true;
    }
  }

  initWebApp(){
    console.log("init web app !");
  }

  translateMenu() {
    this.pages.push({id: 1, title : 'MENU.BRIEFCASE', component : BriefcasePage, icon : 'ios-folder-outline'});
    // this.pages.push({id: 2, title : 'MENU.FILROUGE', component : FilRougePage, icon : 'ios-star-outline'});
    this.pages.push({id: 3, title : 'MENU.RECENTS', component : RecentsPage, icon : 'ios-time-outline'});
    if (this.isIosPlatform) {
      this.pages.push({id: 4, title : 'MENU.FAVORITES', component : FavoritesPage, icon : 'ios-bookmark-outline'});
    }
    this.pages.push({id: 5, title : 'MENU.SEARCH', component : SearchPage, icon : 'ios-search-outline'});
    if (this.isIosPlatform) {
      this.pages.push({id: 6, title : 'MENU.LOCALFILES', component : LocalFilesPage, icon : 'ios-document-outline'});
    }
    this.pages.push({id: 7, title : 'MENU.NOTIFICATIONS', component : NotificationsPage, icon : 'ios-notifications-outline'});
    if (this.isIosPlatform) {
      this.pages.push({id: 8, title : 'MENU.EMAIL_PACKAGE', component : EmailPackagePage, icon : 'ios-mail-outline'});
    }
    this.activePage = this.pages[0];
    this.helperService.setActivePage(this.activePage.component);
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
    this.activePage = page;
    this.helperService.setActivePage(this.activePage.component);
  }

  checkActivePage(page): boolean{
    return page.component === this.helperService.getActivePage();
  }

  getSynchroDate(){
    this.synchroService.currentSyncDate().subscribe(syncDate => {
      this.lastSyncDate = this.getConvertDate(syncDate);
    });
  }

  getAppVersion() {
    this.appVersion.getVersionNumber().then(
      (versionNumber) => {
        console.log("App Version: ", versionNumber);
        this.currentAppVersion = versionNumber;
      },
      (error) => {
        console.log("Error getting App version: ",error);
      }
    );
  }

  getConvertDate(date){
    let d = new Date(date);
    let dd = d.getDate();
    let mm = d.getMonth() + 1; //January is 0!
    let yyyy = d.getFullYear();

    let hh = d.getHours();
    let min = d.getMinutes();

    let day, month, hours, minutes;

    day = this.addZero(dd);
    month = this.addZero(mm);
    hours = this.addZero(hh);
    minutes = this.addZero(min);

    return day + '/' + month + '/' + yyyy + ' - ' + hours+':'+minutes;
  }

  addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  logOut(){
    if (this.isIosPlatform) {
      this.nav.setRoot(LoginPage);
    }
    else {
      this.authService.logout().subscribe(result => {
        //Do not keep user in storage for Web app
        this.storage.set("user", null).then(() => {
          this.nav.setRoot(LoginPage);
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts